export function omitValues(obj: null, keys: string[]): null;
export function omitValues<T extends Record<string, any>, K extends keyof T>(obj: T, keys: K[]): Omit<T, K>;

export function omitValues<T extends Record<string, any>, K extends keyof T>(obj: T | null | undefined, keys: K[]): Omit<T, K> | null | undefined {
  if (obj === null || obj === undefined) {
    return obj;
  }
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key as K))) as Omit<T, K> | null;
}